import {
  pickDefaultCompany,
  getActiveCompanyId,
  setActiveCompanyId,
  resolvePreferredCompanyId,
  getTokenLastCompanyId,
} from 'utils/activeCompany';
import getSubdomain from 'utils/getSubdomain';

const computeUserLastCompany = user => {
  if (!user) {
    const id = getActiveCompanyId();
    if (!id) {
      return null;
    }
    return { _id: id, subDomain: getSubdomain() || 'x', name: 'x' };
  }

  const lastCompany = pickDefaultCompany(
    user,
    resolvePreferredCompanyId(getTokenLastCompanyId(), null),
  );
  if (!lastCompany) {
    return null;
  }

  const { name, subDomain, _id, isAcceptTerms } = lastCompany;
  setActiveCompanyId(_id);
  return { _id, name, subDomain, isAcceptTerms };
};

export default computeUserLastCompany;
